import React, {
  Dispatch,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../store/reducers';
import { renderRoutes, RouteConfig } from 'react-router-config';
import './style.scss';
import { fetchEnvList } from '../../api/game/env';
import {
  GamesAction,
  getServiceMyFavoriteListAction,
  ReduxGamesActionType,
} from '../../store/modules/games';
import { getServiceList } from '../../api/services';
import { getStudioInfoByGameID } from '../../api';
import {
  convert2Menu,
  getCurrentSelectedMenuID,
  initStudio,
  isBuildRoute,
  setGamePageTitle,
  formatGameParamsByLocationPathname,
  getCurrentStudioGameList,
  getPathnameByGameChange,
  initStudioFailedTip,
  createServiceFavorites,
  getCurrentDefaultEnvID,
  getPathnameByGameService,
  getGosHostname,
  isVersionGreaterThan,
} from './lib';
import { ISelectStudioAction, StudioAction } from '../../store/modules/studio';
import { useHistory, useLocation, matchPath } from 'react-router-dom';
import { IGameURLParams } from '../../model';
import { setLocalStorageStudioId } from '../utils/localstorage';
import { ISystemMenuItem } from '../../model/system/menu';
import { GameMenu } from './game-menu';
import { GameFilter } from './game-filter';
import { IGameEnvModel } from '../../model/api-modules/env';
import { LanguageType, isNumeric, sleep } from '../../lib';
import { Header } from '../component/header';
import { HelpCreateEnvModal } from './common/help-create-env-modal';
import { IAPIGameItem } from '../../model/api-modules';
import { messageError } from '../../components/message';
import getFormatMessage, {
  getLanguage,
} from '../../locales/get-format-message';
import NoviceGuideEn from '../../assets/images/novice-guide-en.png';
import NoviceGuideCn from '../../assets/images/novice-guide-cn.png';
import { getString, setString } from '../../lib/local-storage/interface-base';
import { windowPostMessage } from './lib/window-message';
import { ServiceEvent } from '../../model/event';
import { fetchUserPermission } from '../../store/modules/permission';
import { wrapTimeReport } from '../lib/bk-report';

interface IProps {
  readonly route?: RouteConfig;
}

let initFlag = false;

export const GameConsoleLayoutRouter = (props: IProps) => {
  const history = useHistory();
  const location = useLocation();

  const commonDispatch = useDispatch<any>();
  const studioDispatch = useDispatch<Dispatch<StudioAction>>();
  const gameDispatch = useDispatch<Dispatch<GamesAction>>();
  const selectStudioDispatch = useDispatch<Dispatch<ISelectStudioAction>>();

  const gameList = useSelector((state: IRootState) => state.games.games);
  const allServiceConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  const envs = useSelector((state: IRootState) => state.games.envs);
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );

  const [expandSide, setExpandSide] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [menus, setMenus] = useState<ReadonlyArray<ISystemMenuItem>>([]);
  const myFavoriteList = useSelector(
    (state: IRootState) => state.games.myFavoriteList
  );
  const [pathnameParams, setPathnameParams] = useState<IGameURLParams>({
    gameId: '',
    envId: '',
    serviceId: '',
  });
  const [showTipsModal, setShowTipsModal] = useState<boolean>(false);
  const [selectedGame, setSelectedGame] = useState<IAPIGameItem>();
  const [showCheckModal, setShowCheckModal] = useState<boolean>(false);
  const [hideNoviceGuide, setHideNoviceGuide] = useState<boolean>(false);
  const [syncedServiceId, setSyncedServiceId] = useState<string>();
  const [forceRefreshKey, setForceRefreshKey] = useState<number>(1);
  const NOVICE_GUIDE_CLOSE = 'NOVICE_GUIDE_CLOSE';
  const games = useMemo(() => {
    return getCurrentStudioGameList(gameList, selectStudio?.studioID);
  }, [gameList, selectStudio?.studioID]);

  useEffect(() => {
    const data = initPathnameState();
    if (!isNumeric(data.gameId)) {
      messageError(getFormatMessage('title_access_failed'));
      toHome();
      return;
    }
    initFlag = true;
    wrapTimeReport(() => initialization(data.gameId));
  }, []);

  useEffect(() => {
    const origin = getEnvOrigin();

    if (!origin) {
      return;
    }

    windowPostMessage.on(
      ServiceEvent.SyncServiceRoute,
      syncRouteHandler,
      origin
    );

    return () => {
      windowPostMessage.off(
        ServiceEvent.SyncServiceRoute,
        syncRouteHandler,
        origin
      );
    };
  }, [allServiceConfig, syncedServiceId, envs, location.pathname]);

  useEffect(() => {
    initPathnameState();
  }, [location.pathname]);

  useEffect(() => {
    if (pathnameParams.gameId) {
      queryGameEnvList(pathnameParams.gameId, (data) => {
        intiToEnvRouter(pathnameParams.gameId, data);
      });
    }
  }, [pathnameParams.gameId]);

  useEffect(() => {
    setGamePageTitle(gameList, pathnameParams.gameId);
    if (gameList.length) {
      setSelectedGame(
        gameList.find((item) => item.gameID === pathnameParams.gameId)
      );
    }
  }, [gameList, pathnameParams.gameId]);

  useEffect(() => {
    if (
      !selectStudio?.studioID ||
      !pathnameParams.gameId ||
      !pathnameParams.envId
    ) {
      return;
    }
    fetchUserPermission(commonDispatch)({
      gameID: pathnameParams.gameId,
      envID: Number(pathnameParams.envId),
    });
  }, [selectStudio?.studioID, pathnameParams.gameId, pathnameParams.envId]);

  const getEnvOrigin = () => {
    const matched = matchPath<{ envId: string }>(
      location.pathname,
      '/console/build/:gameId/:envId/:serviceId?'
    );
    const currentEnv = envs.find(
      (item) => item.id === Number(matched?.params.envId)
    );
    if (!currentEnv) {
      return;
    }
    return getGosHostname(currentEnv.GosParams);
  };

  const syncRouteHandler = useCallback(
    (serviceName = '') => {
      const foundService = allServiceConfig?.find(
        (service) =>
          serviceName.toLowerCase().replace(/\W/g, '') ===
          service.Name.toLowerCase().replace(/\W/g, '')
      );
      if (String(syncedServiceId) === String(foundService?.id)) {
        return;
      }
      if (foundService?.id) {
        setSyncedServiceId(String(foundService.id));
        const servicePath = getPathnameByGameService(foundService.id);
        window.document.title = foundService.Name;
        window.history.replaceState(
          window.history.state?.state,
          '',
          servicePath
        );
      }
    },
    [allServiceConfig, syncedServiceId]
  );

  const initPathnameState = () => {
    const data = formatGameParamsByLocationPathname(location.pathname);
    setPathnameParams(data);
    return data;
  };

  const initialization = async (gameID: string) => {
    setLoading(true);
    const studioItem = await queryStudioInfo(gameID);
    if (studioItem) {
      await queryServiceConfigList();
      await getServiceMyFavoriteListAction(commonDispatch, gameID)();
    }
    setLoading(false);
  };

  const intiToEnvRouter = (
    gameID: string,
    envs: ReadonlyArray<IGameEnvModel>
  ) => {
    if (isBuildRoute()) {
      return '';
    }
    const envID = getCurrentDefaultEnvID(gameID, envs);
    history.replace(getPathnameByGameChange(envID));
  };

  const queryServiceConfigList = async () => {
    const data = await getServiceList();
    gameDispatch({
      type: ReduxGamesActionType.ALL_MENU_CONFIG,
      result: data || [],
    });
    setMenus(convert2Menu(data || []));
  };

  const queryGameEnvList = async (
    gameID: string,
    callback?: (res: ReadonlyArray<IGameEnvModel>) => void
  ) => {
    const result = (await fetchEnvList(gameID, true)) || [];
    gameDispatch({
      type: ReduxGamesActionType.SET_ALL_ENVS,
      result,
    });
    callback?.(result);
    if (result.length === 0) {
      setShowTipsModal(true);
      setShowCheckModal(true);
    }
    return result;
  };

  const renderTipsEnvModal = () => {
    if (showTipsModal && selectedGame) {
      return (
        <HelpCreateEnvModal
          showCheckModal={showCheckModal}
          onCloseCheckModal={() => setShowCheckModal(false)}
          onClose={() => setShowTipsModal(false)}
          selectedGame={selectedGame}
        />
      );
    }
    return null;
  };

  const queryStudioInfo = async (gameId: string) => {
    const res = await getStudioInfoByGameID(gameId);
    if (res?.studioItem) {
      const studioRes = await initStudio(
        res.studioItem.StudioID,
        studioDispatch,
        selectStudioDispatch
      );
      if (studioRes) {
        setLocalStorageStudioId(studioRes.studio.studioID);
        return true;
      }
    }

    initStudioFailedTip(gameId, res?.studioItem.StudioID);
    await sleep(1000);
    toHome();
    return false;
  };

  const toHome = () => {
    history.push('/');
  };

  const onToRouter = (pathname: string) => {
    let selectServiceId = selectedMenuID ? Number(selectedMenuID) : 0;
    if (pathname === getPathnameByGameService(selectServiceId)) {
      return;
    }

    let newPathname = pathname;
    const selectServiceItem = allServiceConfig?.find(
      (item) => item.id === selectServiceId
    );
    const params = formatGameParamsByLocationPathname(pathname);
    if (params.envId && params.serviceId) {
      const env = envs.find((item) => item.id === Number(params.envId));
      const itemGos = JSON.parse(env?.GosParams || '{}');
      let isOldMatch = false;
      if (
        !isVersionGreaterThan(itemGos?.GameServiceVersion) &&
        selectServiceItem?.Name === 'Matchmaking'
      ) {
        isOldMatch = true;
      }
      if (isOldMatch) {
        const battleItem = allServiceConfig?.find(
          (item) => item.Name === 'Battle'
        );
        selectServiceId = battleItem?.id || 0;
        const pathnameArr = pathname.split('/');
        pathnameArr.splice(5, 1, `${selectServiceId}`);
        newPathname = pathnameArr.join('/');
      }
    }
    if (syncedServiceId) {
      setForceRefreshKey(forceRefreshKey + 1);
      setSyncedServiceId(undefined);
    }

    history.push(newPathname);
  };

  const fixedMenu = isBuildRoute();
  const selectedMenuID = getCurrentSelectedMenuID(
    syncedServiceId || pathnameParams.serviceId
  );

  const renderMenu = () => {
    return (
      <GameMenu
        selectStudio={selectStudio}
        fixedMenu={fixedMenu}
        onMouseEnter={() => setExpandSide(true)}
        onMouseLeave={() => setExpandSide(false)}
        menus={menus}
        myFavoriteList={myFavoriteList}
        selectedMenuID={selectedMenuID}
        onToRouter={onToRouter}
        addFavorites={(id: number, status: number) =>
          createServiceFavorites(commonDispatch, id, status)
        }
      />
    );
  };

  const renderGameFilter = () => {
    return (
      <>
        {renderNoviceGuide()}
        <GameFilter
          gameList={games}
          pathnameParams={pathnameParams}
          envs={envs}
          onToRouter={onToRouter}
          studioId={selectStudio?.studioID}
        />
      </>
    );
  };

  const clickNoviceGuideConfirm = () => {
    setString(NOVICE_GUIDE_CLOSE, 'true');
    setHideNoviceGuide(true);
  };

  const renderNoviceGuide = () => {
    if (getString(NOVICE_GUIDE_CLOSE || hideNoviceGuide)) {
      return null;
    }
    return (
      <div className="novice-guide-bg">
        <div className="novice-guide-box">
          {getLanguage === LanguageType.zh_CN ? (
            <img src={NoviceGuideCn} className="novice-guide-img" />
          ) : (
            <img src={NoviceGuideEn} className="novice-guide-img" />
          )}
          <div className="novice-guide-btn" onClick={clickNoviceGuideConfirm}>
            {getFormatMessage('novice_guide_btn')}
          </div>
        </div>
      </div>
    );
  };

  if (loading || !initFlag) {
    return null;
  }

  // console.log('xxxx-gameList', gameList)
  // console.log('xxxx-envs', envs)

  return (
    <div className="gc-page-content">
      <Header
        isSmallLogo={true}
        fixedMenu={fixedMenu}
        isHoverLeftSide={expandSide}
        renderGameFilterNode={renderGameFilter()}
      />
      <div className="gc-console">
        {renderMenu()}
        <div className="gc-console-content" key={forceRefreshKey}>
          {renderRoutes(props.route?.routes)}
          {renderTipsEnvModal()}
        </div>
      </div>
    </div>
  );
};
